import type { VolumeDataItem } from "@/domains/landing-page/components/volume-chart"
import VolumeChart from "@/domains/landing-page/components/volume-chart"

export interface VolumeViewProps {
  data: Array<VolumeDataItem> | undefined
  isLoading: boolean
}

export function VolumeView({ data, isLoading }: VolumeViewProps) {
  const sliceLength = 3 * 120

  return (
    <div className="h-fit w-full rounded-lg border border-p300-light bg-p300 px-8 py-8 text-t100">
      <h1 className="mb-1 text-xl font-bold capitalize md:text-2xl">Volume</h1>
      <p className="mb-8 text-lg text-t200">We are building new volume streams on base.</p>

      {!isLoading && data ? (
        <div className="flex flex-col gap-8">
          <VolumeChart data={data.slice(0, sliceLength)} />
        </div>
      ) : (
        <div className="flex h-full min-h-[320px] w-full items-center justify-center">
          <div className="loading loading-spinner loading-lg text-sm text-t200">Loading..</div>
        </div>
      )}
    </div>
  )
}
